// Army Career Paths with ASVAB requirements and job examples

const careerPaths = [
  {
    id: 'combat',
    name: 'Combat',
    description: 'Requires high scores in the Verbal Expression, Auto and Shop Information, and Mechanical Comprehension subjects and leads to jobs like the Infantryman (11B).',
    requiredSubjects: ['Verbal Expression', 'Auto and Shop Information', 'Mechanical Comprehension'],
    exampleJob: 'Infantryman (11B)',
    icon: '⚔️'
  },
  {
    id: 'skilled-technical',
    name: 'Skilled Technical',
    description: 'Requires high scores in the General Sciences, Verbal Expression, Mechanical Comprehension, and Mathematics Knowledge subjects and leads to jobs like the Ammunition Specialist (89B).',
    requiredSubjects: ['General Science', 'Verbal Expression', 'Mechanical Comprehension', 'Mathematics Knowledge'],
    exampleJob: 'Ammunition Specialist (89B)',
    icon: '🎖️'
  },
  {
    id: 'surveillance-communication',
    name: 'Surveillance & Communication',
    description: 'Requires high scores in the Verbal Expression, Arithmetic Reasoning, Auto and Shop Information, and Mechanical Comprehension subjects and leads to jobs like the Electronic Warfare Specialist (17E).',
    requiredSubjects: ['Verbal Expression', 'Arithmetic Reasoning', 'Auto and Shop Information', 'Mechanical Comprehension'],
    exampleJob: 'Electronic Warfare Specialist (17E)',
    icon: '📡'
  },
  {
    id: 'electronics',
    name: 'Electronics',
    description: 'Requires high scores in General Sciences, Arithmetic Reasoning, Mathematics Knowledge, and Electronic Information subjects and leads to jobs like the Radar Repairer (94M).',
    requiredSubjects: ['General Science', 'Arithmetic Reasoning', 'Mathematics Knowledge', 'Electronics Information'],
    exampleJob: 'Radar Repairer (94M)',
    icon: '🔌'
  },
  {
    id: 'field-artillery',
    name: 'Field Artillery',
    description: 'Requires high scores in the Arithmetic Reasoning, Mathematics Knowledge, and Mechanical Comprehension subjects and leads to jobs like the Field Artillery Recruit (13U).',
    requiredSubjects: ['Arithmetic Reasoning', 'Mathematics Knowledge', 'Mechanical Comprehension'],
    exampleJob: 'Field Artillery Recruit (13U)',
    icon: '🎯'
  },
  {
    id: 'general-maintenance',
    name: 'General Maintenance',
    description: 'Requires high scores in the General Science, Auto and Shop Information, Mathematics Knowledge, and Electronics Information subjects and leads to jobs like the Parachute Rigger (92R).',
    requiredSubjects: ['General Science', 'Auto and Shop Information', 'Mathematics Knowledge', 'Electronics Information'],
    exampleJob: 'Parachute Rigger (92R)',
    icon: '🔧'
  },
  {
    id: 'general-technical',
    name: 'General Technical',
    description: 'Requires high scores in the Verbal Expression and Arithmetic Reasoning subjects and leads to jobs like the Stryker Systems Maintainer (91S).',
    requiredSubjects: ['Verbal Expression', 'Arithmetic Reasoning'],
    exampleJob: 'Stryker Systems Maintainer (91S)',
    icon: '⚙️'
  },
  {
    id: 'clerical',
    name: 'Clerical',
    description: 'Requires high scores in the Verbal Expression, Arithmetic Reasoning, and Mathematics Knowledge subjects and leads to jobs like the Human Resources Specialist (42A).',
    requiredSubjects: ['Verbal Expression', 'Arithmetic Reasoning', 'Mathematics Knowledge'],
    exampleJob: 'Human Resources Specialist (42A)',
    icon: '📋'
  },
  {
    id: 'mechanical-maintenance',
    name: 'Mechanical Maintenance',
    description: 'Requires high scores in the Auto and Shop Information, Mechanical Comprehension, and Electronic Information subjects and leads to jobs like the Self Propelled Artillery Maintainer (91P).',
    requiredSubjects: ['Auto and Shop Information', 'Mechanical Comprehension', 'Electronics Information'],
    exampleJob: 'Self Propelled Artillery Maintainer (91P)',
    icon: '🔩'
  },
  {
    id: 'operators-food',
    name: 'Operators & Food',
    description: 'Requires high scores in the Verbal Expression, Auto and Shop Information, and Mechanical Comprehension subjects and leads to jobs like the Culinary Specialist (92G).',
    requiredSubjects: ['Verbal Expression', 'Auto and Shop Information', 'Mechanical Comprehension'],
    exampleJob: 'Culinary Specialist (92G)',
    icon: '🍳'
  }
];

export default careerPaths;
